import { FabricSampleAddressFields } from '../../redux/productdetail/fabricSample';
import validationHelper from './validationHelper';

const INVALID_EMAIL_MSG = 'Email is invalid';
const GENERAL_ERROR_MSG = 'Field is required';

const GENERAL_FIELDS = ['name', 'street', 'city', 'country'];

export default (formValues: FabricSampleAddressFields) => {
    const errors: FabricSampleAddressFields = GENERAL_FIELDS.reduce((errors, fieldName) => {
        if (!validationHelper.isNotEmpty(formValues[fieldName])) {
            return { ...errors, [fieldName]: GENERAL_ERROR_MSG };
        }
        return errors;
    }, {});

    if (!validationHelper.isValidEmail(formValues.email || '')) {
        errors.email = INVALID_EMAIL_MSG;
    }

    if (!validationHelper.isValidZip(formValues.postcode || '')) {
        errors.postcode = GENERAL_ERROR_MSG;
    }

    return errors;
};
